<app-fr-card *ngIf="theme === 'v1'" (click)="openDialog(viewSupporters)">
  <div class="fr-view-supporters">
    <img loading="lazy" class="fr-spporters-img" [attr.data-src]="supporterImg" alt="all supporters" />
    <span class="supporter" *ngIf="fundraiser?.raised?.backers">
      <div class="view-all-txt">{{'Stories.donations.viewNoSupporter1' | translatePipe | async}} {{ fundraiser.raised.backers }} {{'Stories.donations.viewNoSupporter2' | translatePipe | async}}</div>
      <mat-icon class="s-icon">arrow_forward</mat-icon>
    </span>
  </div>
</app-fr-card>

<app-signin-signup [popupView]="true" [numberOnly]="true" [showPopup]="loginPopupState" [noRedirectAfterLogin]="true" (onClose)="signinClose(viewSupporters)" />

<div *ngIf="theme === 'v3'" class="view-supporters-v3">
  <img loading="lazy" class="spporters-img" [attr.data-src]="supporterImg" alt="all supporters" />
  <div class="supporter" *ngIf="fundraiser?.raised?.backers">
    {{fundraiser.raised.backers}} {{'Stories.donors' | translatePipe | async}}
  </div>
  <button class="view-all" (click)="openDialog(viewSupporters)" mat-button>
    {{'Stories.donations.viewNoSupporter1' | translatePipe | async}}
  </button>
</div>

<div *ngIf="theme === 'v4'" class="view-supporters-v4" (click)="openDialog(viewSupporters)">
  <div class="donors-img">
    <img loading="lazy" [attr.data-src]="supporterImg" alt="all supporters" />
  </div>
  <div>
    <div class="supporters-count">{{fundraiser?.raised?.backers | inrFormat:'INR'}}</div>
    <div class="donors-text">{{'Stories.donors' | translatePipe | async}}</div>
  </div>
</div>

<div *ngIf="theme === 'v5'" class="view-supporters-v5" (click)="openDialog(viewSupporters)">
  <div class="donors-img">
    <img loading="lazy" src="../assets/images/donorsthreeimg.png" alt="all supporters" />
  </div>
  <div class="donor-count">
    <div class="supporters-count">{{fundraiser?.raised?.backers | inrFormat:'INR'}}</div>
    <div class="donors-text">{{'Stories.donors' | translatePipe | async}}</div>
  </div>
</div>

<!-- Contact Fundraiser -->
<ng-template #viewSupporters>
  <div class="fr-dialog">
    <div *ngIf="isMobile && vars.showKCart" class="closeLine" (click)="closeDialog()"></div>
    <div *ngIf="isMobile && vars.showKCart" class="closeLineBorder"></div>
    <div class="fr-dialog-header" mat-dialog-title>
      <div class="fr-dialog-heading">
        <div class="fr-dialog-title" *ngIf="fundraiser?.raised?.backers">
          <mat-icon class="icon-users fr-dialog-icon"></mat-icon>
          <span>{{ fundraiser.raised.backers }} Supporters</span>
        </div>
        <button class="close-btn" (click)="dialog.closeAll()" mat-icon-button><mat-icon>close</mat-icon></button>
      </div>
      <div class="line"></div>
      <div *ngIf="!fundraiser?.settings?.norecenttab && origin !== 'stories'" class="vs-sort">
        <a class="vs-sort-btn" [ngClass]="getSortOrder('donated_amount')" (click)="sortDonors('donated_amount')" mat-button>Most Generous</a>
        <span>|</span>
        <a class="vs-sort-btn" [ngClass]="getSortOrder('id')" (click)="sortDonors('id')" mat-button>Recent</a>
      </div>
    </div>
    <div (scroll)="onScroll($event, 'scroll')" class="fr-content" [ngClass]="{'overflow-hidden': donorError?.error?.error}" mat-dialog-content>
       <div class="supporter-Section-bank" *ngIf="!isFundraiserEnded && currencyInfo?.currency=='INR' && vars.paymentOption" data-bg="../assets/images/upi-card-bg.png">
        <span class="heading">Contributed VIA BANK / PAYTM / UPI ?</span>
        <span class="click-here"><a (click)="ackPopup()">Click here</a> if you can't find your contribution listed below.</span>
      </div>
      <div class="loading-block" *ngIf="isLoader"></div>
        <div class="tl-unauth" *ngIf="donorError">
        <div class="tl-signin-view" *ngIf="donorError?.status==401">
          <span class="tl-unauth-txt">You need to sign in to view more Supporters.</span>
          <app-button class="tl-unauth-btn" btnClass="primary-btn" label="Sign In" (click)="navigateToSignIn()"></app-button>
        </div>
        <div *ngIf="donorError?.status==403">
          <span class="tl-unauth-txt">Only supporters of this fundraiser can view more supporters.</span>
          <app-donate-now *ngIf="!isFundraiserEnded && vars.campaignType!=='stories'" [fundraiser]="fundraiser" class="tl-unauth-btn" label="Contribute" [position]="5"></app-donate-now>
        </div>
      </div>
      <app-placeholder-loader *ngIf="!supportersOnScroll.length" type="donor" [count]="6"></app-placeholder-loader>
      <div *ngFor="let item of supportersOnScroll">
        <app-donor [donor]="item" [showTime]="donorsOrderBy=='creation_date'" [version]="vars.showKCart ? 2 : 1"></app-donor>
        <div *ngFor="let comment of (item.comments ? item.comments.slice(0,1): [])" class="list-comment"><i class="icon-leftquote quotes-icon"></i>{{comment.text}}<i class="icon-rightquote quotes-icon"></i></div>
      </div>
    </div>
  </div>
</ng-template>
<app-tickr *ngIf="util.isBrowser && (vars.pageName === 'stories' || isMobile) && tickrIsShown && !tickrService.stopTickr && !isFundraiserEnded && !donationCard && !isDonated && fundraiser?.raised?.raised"
          [skipSipTicker]="fundraiser?.beneficiary?.entity_type==='ngo'">
</app-tickr>
